<template>
    <div class="variations-sidebar">
        <CollapsibleWidget is-opened>
            <template #name>Languages</template>

            <template #controls>
                <Badge v-if="selectedLanguages.length" :count="selectedLanguages.length" class="filter-badge-count" />
            </template>

            <LibraryCheckboxGroup
                v-if="languageOptions"
                v-model="filtersStore.selectedLanguages"
                :options="languageOptions"
            />
        </CollapsibleWidget>

        <CollapsibleWidget is-opened>
            <template #name>Sizes</template>

            <template #controls>
                <Badge v-if="selectedSizes.length" :count="selectedSizes.length" class="filter-badge-count" />
            </template>

            <LibraryCheckboxGroup v-if="sizeOptions" v-model="filtersStore.selectedSizes" :options="sizeOptions" />
        </CollapsibleWidget>

        <div class="group-filters-wrap">
            <CollapsibleWidget v-if="editableGroupOptions" content-padding="none">
                <template #name>Content</template>

                <template #controls>
                    <Badge
                        v-if="allSelectedGroupIds.length"
                        :count="allSelectedGroupIds.length"
                        class="filter-badge-count"
                    />
                </template>

                <div
                    v-for="editableGroup in editableGroupOptions"
                    :key="editableGroup.name"
                    class="group-filters-group"
                >
                    <CollapsibleWidget size="small">
                        <template #name>
                            <span class="capitalize-text">{{ editableGroup.name }}</span>
                        </template>
                        <template #controls>
                            <Badge
                                v-if="totalSelectedInGroup(editableGroup)"
                                :count="totalSelectedInGroup(editableGroup)"
                                class="filter-badge-count"
                            />
                        </template>

                        <LibraryCheckboxGroup
                            :model-value="filtersStore.selectedEditableIdsByGroup[editableGroup.name]"
                            :options="editableGroup.editableOptions"
                            @update:modelValue="filtersStore.setSelectedGroupIdsByGroup(editableGroup.name, $event)"
                        />
                    </CollapsibleWidget>
                </div>
            </CollapsibleWidget>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import { useConnectStore } from "@/Connect/store";
import { totalSelectedInGroup, useConnectFiltersStore } from "@/Connect/store/filters";

import LibraryCheckboxGroup from "@/components/Campaign/LibraryCheckboxGroup.vue";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";

const connectStore = useConnectStore();
const filtersStore = useConnectFiltersStore();

/** COMPUTED */
const languageOptions = computed(() => connectStore.languageOptions);
const sizeOptions = computed(() => connectStore.sizeOptions);
const editableGroupOptions = computed(() => connectStore.editableGroupOptions);

const selectedLanguages = computed(() => filtersStore.selectedLanguages);
const selectedSizes = computed(() => filtersStore.selectedSizes);
const allSelectedGroupIds = computed(() => filtersStore.allSelectedGroupIds);
</script>

<style lang="css" scoped>
.variations-sidebar {
    overflow-y: auto;

    flex: 0 0 300px;

    background-color: #ffffff;
}
</style>

<style lang="scss">
@use "@style/variables" as *;

.group-filters-wrap {
    & > .ivu-collapse > .ivu-collapse-item-active {
        border-bottom: 1px solid $cmp-light-filters-border-color;
    }

    .collapsible-widget--small {
        &.ivu-collapse > .ivu-collapse-item-active {
            border-bottom: 1px solid #ffffff;
        }

        &.ivu-collapse > .ivu-collapse-item {
            > .ivu-collapse-header {
                padding: 0 0 0 $spacing-large;
                border: none;

                &:hover {
                    background: $cmp-light-filters-hover-color;
                }
            }
        }
    }
}
</style>

<style lang="scss">
@use "@style/variables" as *;

.editable-group-checkbox-list {
    & > .ivu-collapse > .ivu-collapse-item-active .ivu-collapse-header {
        border-bottom: 1px solid $cmp-light-filters-border-color;
    }

    .collapsible-widget--small {
        &.ivu-collapse > .ivu-collapse-item {
            > .ivu-collapse-header {
                padding: 0 0 0 $spacing-large;
                border: none;

                &:hover {
                    background: $cmp-light-filters-hover-color;
                }
            }
        }
    }
}
</style>
